import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { UpploadEffect } from "../../effect";
import Cropper from "cropperjs";
import { safeListen, fitImageToContainer, canvasToBlob } from "../../helpers/elements";

var Rotate = /*#__PURE__*/function (_UpploadEffect) {
  _inherits(Rotate, _UpploadEffect);

  var _super = _createSuper(Rotate);

  function Rotate() {
    var _this;

    _classCallCheck(this, Rotate);

    _this = _super.apply(this, arguments);
    _this.name = "rotate";
    _this.icon = "<svg aria-hidden=\"true\" viewBox=\"0 0 256 256\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M139 37a110 110 0 014 218v-37a73 73 0 00-4-144v36L66 55l73-55v37zM61 234c15 11 33 18 52 21v-37c-9-2-18-6-25-11l-27 27zm-20-21c-12-15-19-33-22-52h37c2 9 6 18 11 26l-26 26zM40 81c-11 14-19 32-21 51h37c2-11 7-21 13-29L40 81z\" fill=\"#000\" fill-rule=\"nonzero\"/></svg>";
    _this.value = 0;
    _this.max = 360;
    _this.unit = "deg";
    _this.originalFile = {
      blob: new Blob()
    };

    _this.template = function (_ref) {
      var file = _ref.file,
          translate = _ref.translate;
      var image = URL.createObjectURL(file.blob);
      _this.originalFile = file;
      return "\n      <div class=\"uppload-rotating-element\">\n        <img style=\"width: 20px\" alt=\"\" src=\"".concat(image, "\">\n      </div>\n      <div class=\"settings\">\n        <input type=\"range\" value=\"").concat(_this.value, "\" min=\"0\" max=\"").concat(_this.max, "\">\n        <span class=\"value\"><span>0</span>").concat(translate("units.".concat(_this.unit)) || _this.unit, "</span>\n      </div>\n    ");
    };

    _this.handlers = function (params) {
      var rotatorElement = params.uppload.container.querySelector(".uppload-rotating-element img");
      var originalFile = _this.originalFile;

      if (rotatorElement) {
        fitImageToContainer(params, rotatorElement).then(function () {
          var rotator = new Cropper(rotatorElement, {
            autoCropArea: 1,
            viewMode: 1,
            dragMode: "none",
            cropBoxMovable: false,
            cropBoxResizable: false,
            toggleDragModeOnDblclick: false,
            ready: function ready() {
              params.uppload.emitter.emit("processing");
              canvasToBlob(rotator.getCroppedCanvas()).then(function (blob) {
                originalFile.blob = blob;
                params.uppload.emitter.emit("process");
                params.next(originalFile);
              });
            }
          });
          var range = params.uppload.container.querySelector(".settings input[type='range']");
          if (range) safeListen(range, "change", function () {
            var value = 0;
            var range = params.uppload.container.querySelector(".settings input[type='range']");
            if (range) value = parseInt(range.value);
            var displayer = params.uppload.container.querySelector(".settings .value span");
            if (displayer) displayer.innerHTML = value.toString();
            rotator.rotate(value - _this.value);
            _this.value = value;
            params.uppload.emitter.emit("processing");
            canvasToBlob(rotator.getCroppedCanvas()).then(function (blob) {
              originalFile.blob = blob;
              params.uppload.emitter.emit("process");
              params.next(originalFile);
            });
          });
        });
      }
    };

    return _this;
  }

  return Rotate;
}(UpploadEffect);

export { Rotate as default };